import { useSelector } from 'react-redux';
import { TargetPage } from '@1po/1po-bff-fe-spec/generated/backoffice/information/model/InformationBanner';
import { RootState } from 'app/AppStore';
import { BANNER_HEIGHT } from 'components/Page/Header/AdvertisementSpace/InformationBanner';
import { getBannersCount } from 'domains/information/Information.store';

export const OFFSET_HEADER = 64;
export const OFFSET_SUB_HEADER = 48;
export const OFFSET_LINK_TABS = 40;
export const OFFSET_VEHICLE_INFO = 70;
export const OFFSET_VEHICLE_INFO_COMPACT = 52;
export const OFFSET_PADDING = 15;
export const OFFSET_CATALOG_HEADER_COLLAPSED = 92;
export const OFFSET_CATALOG_TAB_BAR = 52;
export const OFFSET_CATALOG_HEADER_EXPANDED_EXTRA = 72;
export const CATALOG_HEADER_TOP_SPACING = 12;

export const OFFSET_CATALOG = OFFSET_SUB_HEADER + OFFSET_VEHICLE_INFO + OFFSET_VEHICLE_INFO_COMPACT + OFFSET_PADDING;

export const useOffsetTop = (page: TargetPage | 'ESTIMATE' | 'MY_STORE') => {
  const isBanners = useSelector((state: RootState) => getBannersCount(state, page)) > 0;

  return OFFSET_HEADER + (isBanners ? BANNER_HEIGHT : 0);
};

export const useOffsetTopVehicleCatalog = (page: TargetPage | 'ESTIMATE' | 'MY_STORE') => {
  const offsetTop = useOffsetTop(page);
  if (page === 'RENAULT_CATALOG' || page === 'OTHER_BRANDS_CATALOG') {
    return offsetTop + OFFSET_SUB_HEADER + OFFSET_LINK_TABS + OFFSET_VEHICLE_INFO_COMPACT + OFFSET_PADDING;
  } else {
    return offsetTop;
  }
};

export const useOffsetTopCatalogBanner = (page: TargetPage, isHeaderExpanded: boolean) => {
  const offsetTop = useOffsetTop(page);
  const headerHeight = isHeaderExpanded
    ? OFFSET_CATALOG_HEADER_COLLAPSED + OFFSET_CATALOG_HEADER_EXPANDED_EXTRA
    : OFFSET_CATALOG_HEADER_COLLAPSED;

  return offsetTop + OFFSET_SUB_HEADER + headerHeight + OFFSET_CATALOG_TAB_BAR + OFFSET_PADDING;
};

export const getCatalogStickyTopOffset = (
  offsetTop: number,
  catalogPage: TargetPage,
  hasAdvertisementBanner: boolean,
): number => {
  const isIamOtherBrands = catalogPage === 'OTHER_BRANDS_CATALOG';
  const iamBannerAdjustment = isIamOtherBrands && hasAdvertisementBanner ? CATALOG_HEADER_TOP_SPACING : 0;

  return offsetTop + OFFSET_SUB_HEADER - iamBannerAdjustment;
};

export const shouldSuppressIamCatalogTopSpacing = (catalogPage: TargetPage, hasAdvertisementBanner: boolean): boolean =>
  catalogPage === 'OTHER_BRANDS_CATALOG' && !hasAdvertisementBanner;
